/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gross_Lucky_Iguana_ScoldInputs */

const fr_gross_lucky_iguana_scold = /** @type {(inputs: Gross_Lucky_Iguana_ScoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choix des packs`)
};

/**

* @param {Gross_Lucky_Iguana_ScoldInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const gross_lucky_iguana_scold = /** @type {((inputs?: Gross_Lucky_Iguana_ScoldInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gross_Lucky_Iguana_ScoldInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_gross_lucky_iguana_scold(inputs)
});